import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers-sales', storeModule.createStoreModule('customers-sales'))
